/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const isArchive = (contentType: string | undefined): boolean => {
  const archiveMimeTypes = ['application/gzip', 'application/x-tar', 'application/x-gzip'];
  if (!contentType) {
    return false;
  }
  return archiveMimeTypes.includes(contentType);
};
